import { useFormContext } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Typography } from '@mui/material';
import BasicSelect from 'further-ui/components/BasicSelect';
import { getInvestorAllocationTypeLabels } from 'further-ui/labels';
import CombinedInvestorAllocationsTable from './CombinedInvestorAllocationsTable';
import { AllocationRule } from 'further-types/lp/allocations';
import useSyncInvestorAllocations from '../../../hooks/useSyncInvestorAllocations';
import { InvestmentAllocation } from '../../../types';
import { Row } from 'further-ui/components/Layout';
import ColorIndicatorWithText from 'components/new/ColorIndicatorWithText';
import FormField from 'further-ui/components/FormField';

type Props = {
  currency: CurrencyCode;
  considerationIndex: number;
  investmentAllocation: Array<InvestmentAllocation>;
  flatInvestmentAllocations: Array<InvestmentAllocation>;
};
const InvestmentSplitPerInvestorTable: React.FC<Props> = ({
  currency,
  considerationIndex,
  investmentAllocation,
  flatInvestmentAllocations,
}) => {
  const { getValues } = useFormContext<rules.CreateRealisationFormValues>();

  const { setInvestorAllocationType } = useSyncInvestorAllocations();

  const dropdownValue = investmentAllocation[0].allocationType;

  const assetName = getValues('assetName');

  const allocationTypesOptions = [
    {
      value: AllocationRule.PerOriginalInvestment,
      label: getInvestorAllocationTypeLabels(
        AllocationRule.PerOriginalInvestment,
        assetName,
      ),
    },
    {
      value: AllocationRule.Manual,
      label: getInvestorAllocationTypeLabels(AllocationRule.Manual, assetName),
    },
  ];

  const onDropdownChange = (value: AllocationRule) => {
    setInvestorAllocationType({
      considerationIndex,
      investmentId: investmentAllocation[0].investmentId,
      newAllocationType: value,
    });
  };

  return (
    <>
      <Row
        centered
        fullWidth
        spacing="sm"
        justify="space-between"
        breakpoint="md"
      >
        <Typography variant="h6">
          <ColorIndicatorWithText
            text={`Investment on ${investmentAllocation[0].investmentDate?.toReadable()}`}
          />
        </Typography>
        <FormField size="md">
          <BasicSelect
            value={dropdownValue}
            fullWidth
            options={allocationTypesOptions}
            onChange={onDropdownChange}
          />
        </FormField>
      </Row>
      <CombinedInvestorAllocationsTable
        currency={currency}
        considerationIndex={considerationIndex}
        investmentAllocation={investmentAllocation}
        flatInvestmentAllocations={flatInvestmentAllocations}
      />
    </>
  );
};

export default InvestmentSplitPerInvestorTable;
